var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIIcon = function SvgIIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M12.41 8.424c-.543 0-.96-.4-.96-.944a.94.94 0 0 1 .96-.944c.56 0 .96.416.96.944 0 .544-.4.944-.96.944m.8 3.28v3.52c0 .304 0 .56.049.752.08.272.208.432.448.56.128.048.288.096.464.112V17h-3.52v-.352c.176-.016.336-.064.448-.112.256-.128.384-.288.448-.56.064-.192.064-.448.064-.752v-3.392c0-.256 0-.608-.064-.768a.7.7 0 0 0-.288-.384 1.36 1.36 0 0 0-.64-.176v-.352h2.512c.08 0 .112.032.112.112-.016.368-.032.784-.032 1.44"
  })));
};
export default SvgIIcon;